const ResumePage = () => {
    return <>
        <main id="main">
            <section id="resume" className="resume py-5 mt-5">
            <div className="container" data-aos="fade-up">

                <div className="section-title text-center mb-5">
                    <h2 className="fw-bold text-uppercase position-relative d-inline-block pb-2">Resume</h2>
                    <p className="text-muted mt-2">A timeline of my academic research, industry engineering experience, and
                        technical leadership.</p>
                </div>

                <div className="row">
                    <div className="col-lg-6">
                        <h3 className="resume-title text-dark fw-bold border-bottom pb-2 mb-4">Summary</h3>
                        <div className="resume-item pb-4 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">Er. Bimal Adhikari</h4>
                            <p className="text-muted"><em>PhD Candidate in Computer Engineering specializing in RF
                                    Fingerprinting and physical-layer wireless security, combined with over two years of
                                    professional enterprise full-stack development experience.</em></p>
                            <ul className="list-unstyled text-muted small">
                                <li className="mb-1"><i className="bi bi-geo-alt-fill me-2" style={{color: "#34b7a7"}}></i>
                                    Fayetteville, AR</li>
                                <li className="mb-1"><i className="bi bi-telephone-fill me-2" style={{color: "#34b7a7"}}></i> +1
                                    (479) 332-9310</li>
                                <li className="mb-1"><i className="bi bi-envelope-fill me-2" style={{color: "#34b7a7"}}></i>
                                    bimaladhikariofficials@gmail.com</li>
                            </ul>
                        </div>

                        <h3 className="resume-title text-dark fw-bold border-bottom pb-2 mb-4 mt-4">Education</h3>

                        <div className="resume-item pb-4 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">Ph.D. in Computer Engineering</h4>
                            <span className="badge px-3 py-2 my-2 text-uppercase text-white"
                                style={{backgroundColor: "#34b7a7"}}>Aug 2024 - Present</span>
                            <p className="fw-semibold text-secondary mb-1">University of Arkansas (UAF) — Fayetteville, AR
                            </p>
                            <p className="text-muted small">
                                <strong>Focus:</strong> RF Fingerprinting, Physical-Layer Security, and Deep Learning
                                for Wireless Systems.<br/>
                                {/* <!-- <strong>Dissertation:</strong> Deep Learning-Based RF Fingerprinting Under Real-World Hardware Impairments. --> */}
                            </p>
                        </div>

                        <div className="resume-item pb-4 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">B.E. in Computer Engineering</h4>
                            <span className="badge bg-secondary px-3 py-2 my-2 text-uppercase">Graduated May 2022</span>
                            <p className="fw-semibold text-secondary mb-1">Tribhuvan University, National College of
                                Engineering — Nepal</p>
                            <p className="text-muted small">
                                Graduated with a solid foundation in Software Architecture, Network Security, and
                                Systems Engineering. Coursework included fundamental studies in Electromagnetics,
                                foundational Data Security principles, and introductory Cryptographic techniques aligned
                                with the IOE TU curriculum.
                            </p>
                        </div>

                        <h3 className="resume-title text-dark fw-bold border-bottom pb-2 mb-4 mt-4">Peer-Reviewed
                            Publications</h3>

                        <div className="resume-item pb-4 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">"Environment-Agnostic RF Fingerprinting through
                                Protocol-Compliant IQ Imbalance Estimation"</h4>
                            <span className="badge bg-none text-dark px-3 py-2 my-2 text-uppercase">IEEE Conference on Communications and Network Security (CNS) 2026</span>
                            <p className="text-muted small"><em>Accepted for presentation and publication in
                                    proceedings.</em> Focuses on leveraging baseline IQ parameters for robust hardware
                                identity extraction independent of environmental factors.</p>
                        </div>

                        <div className="resume-item pb-4 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">"An Adversarial-Driven Experimental Study on Deep
                                Learning for RF Fingerprinting"</h4>
                            <span className="badge bg-none text-dark px-3 py-2 my-2 text-uppercase">IEEE Military Communications Conference (MILCOM) 2025</span>
                            <p className="text-muted small">Evaluates the impact of adversarial signal perturbations on deep
                                learning models deployed for physical-layer identification under over-the-air test
                                constraints.</p>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <h3 className="resume-title text-dark fw-bold border-bottom pb-2 mb-4">Professional & Research
                            Experience</h3>

                        <div className="resume-item pb-4 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">Graduate Research Assistant (RF & Deep Learning)</h4>
                            <span className="badge px-3 py-2 my-2 text-uppercase text-white"
                                style={{backgroundColor: "#34b7a7"}}>Aug 2024 - Present</span>
                            <p className="fw-semibold text-secondary mb-1">University of Arkansas, Dept. of CSCE —
                                Fayetteville, AR</p>
                            <ul className="text-muted small ps-3">
                                <li className="mb-2">Designed and implemented advanced deep learning frameworks (CNN/ResNet)
                                    to profile physical hardware traits over-the-air.</li>
                                <li className="mb-2">Analyzed adversarial machine learning vulnerabilities (FGSM/PGD
                                    attacks) on RF signals, generating data-augmentation defense models.</li>
                                <li className="mb-2">Architectured custom signal processing code pipelines using PyTorch,
                                    NumPy, and SciPy for feature scaling and data synchronization.</li>
                            </ul>
                        </div>

                        <div className="resume-item pb-4 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">Fullstack Software Developer</h4>
                            <span className="badge bg-secondary px-3 py-2 my-2 text-uppercase">Jun 2022 - Jul 2024</span>
                            <p className="fw-semibold text-secondary mb-1">H.T. Solution Pvt. Ltd. (Himalayan Techies) —
                                Kathmandu, Nepal</p>
                            <ul className="text-muted small ps-3">
                                <li className="mb-2">Engineered scalable modular components for enterprise ERP environments
                                    using the Laravel framework and PHP.</li>
                                <li className="mb-2">Optimized complex relational architecture across PostgreSQL instances,
                                    boosting system response efficiency by roughly 40%.</li>
                                <li className="mb-2">Built high-throughput RESTful APIs integrated with payment processing
                                    and vendor logistical APIs.</li>
                            </ul>
                        </div>

                        <div className="resume-item pb-4 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">Lecturer (Part-Time)</h4>
                            <span className="badge bg-secondary px-3 py-2 my-2 text-uppercase">Mar 2023 - Jul 2024</span>
                            <p className="fw-semibold text-secondary mb-1">Asian College of Higher Studies — Lalitpur, Nepal
                            </p>
                            <ul className="text-muted small ps-3">
                                <li>Instructed undergraduate engineering sections covering Core Web Technologies, RDBMS
                                    Concepts, and Systems Networking.</li>
                            </ul>
                        </div>

                        <h3 className="resume-title text-dark fw-bold border-bottom pb-2 mb-4 mt-4">Leadership & Community
                        </h3>

                        <div className="resume-item pb-4 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">Board of Advisors (BOA) Member</h4>
                            <span className="badge px-3 py-2 my-2 text-uppercase text-white"
                                style={{backgroundColor: "#34b7a7"}}>2025 - Present</span>
                            <p className="fw-semibold text-secondary mb-1">NWA Nepali Samaj — Northwest Arkansas</p>
                            <p className="text-muted small">Providing strategic direction, program management oversight, and
                                collaborative support for regional community development programs across Northwest
                                Arkansas.</p>
                        </div>

                        <div className="resume-item pb-4 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">President</h4>
                            <span className="badge px-3 py-2 my-2 text-uppercase text-white"
                                style={{backgroundColor: "#34b7a7"}}>Aug 2025 - Present</span>
                            <p className="fw-semibold text-secondary mb-1">Nepalese Student Association at UArk —
                                Fayetteville, AR</p>
                            <p className="text-muted small">Leading community governance, organizing cultural outreach
                                initiatives, and managing institutional advocacy pathways for international scholars at
                                the University of Arkansas.</p>
                        </div>


                        <div className="resume-item pb-3 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">Vice Project Lead / Representative</h4>
                            <span className="badge bg-secondary px-3 py-2 my-2 text-uppercase">2021 - 2022</span>
                            <p className="fw-semibold text-secondary mb-1">Code for Change — Kathmandu, Nepal</p>
                            <p className="text-muted small">Directed resource strategies, formed corporate outreach
                                contracts, and managed tech hackathons, workshops, and career readiness events.</p>
                        </div>

                        <div className="resume-item pb-3 position-relative ps-4 border-start"
                            style={{borderLeft: "2px solid #34b7a7 !important"}}>
                            <h4 className="fw-bold text-dark mb-1">President</h4>
                            <span className="badge bg-secondary px-3 py-2 my-2 text-uppercase">2020 - 2021</span>
                            <p className="fw-semibold text-secondary mb-1">National College of Engineering IT Club —
                                Kathmandu, Nepal</p>
                            <p className="text-muted small">
                                Directed overall club operations, strategic planning, and event execution while leading
                                cross-functional student teams. Managed the end-to-end organization of technical
                                workshops, webinars, and inter-collegiate hackathons, and established structured
                                recruitment and training pipelines for incoming members.
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </section>
        </main >
    </>;

};
export default ResumePage;